import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { BaseGetModel } from '../domain/base-get-model'
import { ILicense } from '../Interface/license'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable()
export class LicenseService {
  baseUrl: string
  licensesSubject = new BehaviorSubject<Array<ILicense>>([])

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  static removeEmptyFeatures(licenses: Array<ILicense>) {
    return licenses.map(l => {
      return {
        ...l,
        features: l.features.filter(f => f.title && f.title.trim().length > 0)
      }
    })
  }

  getLicenses(beatmakerId: number): void {
    this.http
      .get<BaseGetModel<ILicense>>(`${this.baseUrl}/web/v1/licenses?beatmakerId=${beatmakerId}`)
      .pipe(
        map(model => {
          model.items = LicenseService.removeEmptyFeatures(model.items)
          return model
        })
      )
      .subscribe(res => {
        this.licensesSubject.next(res.items)
      })
  }

  getLicensesByBeat(beatId: number): Observable<BaseGetModel<ILicense>> {
    return this.http.get<BaseGetModel<ILicense>>(`${this.baseUrl}/web/v1/licenses?beatId=${beatId}`).pipe(
      map(model => {
        model.items = LicenseService.removeEmptyFeatures(model.items)
        return model
      })
    )
  }
}
